// import { usePage } from "@inertiajs/react";
import React, { createContext, useContext, useState, useRef, useEffect } from "react";
import { getBaseRequest, getRequest } from "@components/config/axiosClient";
import { getBrand, getEndpoint, isDefined } from "@components/config/helpers";
import categoryActions from "@components/Redux/Category/actions";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import useCategoryShallowLink from "@components/_hooks/CSRHooks/useCategoryShallowLink";

// import useBreadcrumbsInit from "../InitHooks/useBreadcrumbsInit";

const CategoryContext = createContext();

export const useCategoryContext = () => useContext(CategoryContext);

// Create a provider component
export const CategoryProvider = ({category, children}) => {
    // The value that will be given to the components that consume this context
    const router = useRouter();

    const {
        sort,
        filters,
        selected_filters,
        products,
        total_product_count,
        exactRoute,
    } = category;

    const {template_settings, pageSpinner, pricing_model} = useSelector((state) => state.globalReducer);
    const {categoryState, categoryLoaders} = useSelector((state) => state.categoryReducer);

    const dispatch = useDispatch();
    const isFirstRender = useRef(true);
    const loadingProducts = useRef(false);
    const initialState = useRef(true);

    const [originalRoute, setOriginalRoute] = useState('');
    const [category_sort, setCategorySort] = useState(sort);
    const [available_filters, setCategoryAvailableFilters] = useState(filters);
    const [selected_category_filters, setCategorySelectedFilters] = useState(selected_filters);
    const [catProd, setCategoryProducts] = useState(products);
    const [categoryTotalProductCount, setCategoryTotalProductCount] = useState(total_product_count);
    const [isChecked, setIsChecked] = useState([]);
    const [filterCheckboxValue, setFilterCheckboxValue] = useState(false);
    // const [catData, setCatData] = useState(categoryState?.category.length == 0 ? category : categoryState.category)

    const categoryProducts = categoryState?.category?.length == 0 ? products : categoryState.products
    const catData = categoryState?.category?.length == 0 ? category : categoryState
    const {handleShallowLink} = useCategoryShallowLink(); 

    useEffect(() => {
        setOriginalRoute(router.query.route)
        initialState.current = false;
        // initBreadcrumbs();
        if(categoryState?.category?.length == 0){
            dispatch({
                type: categoryActions.SET_CATEGORY,
                payload: category
            })
        }

        return () => {
            dispatch({type: categoryActions.RESET_CATEGORIES})
        }
    }, [])

    useEffect(() => {
        if(categoryState?.category == null && exactRoute != 'search'){

            const asyncFunction = async () => {
                let obj = {
                    route: router.query.route
                };
    
                const endpoint = await getEndpoint(obj)
                if(categoryState?.newRoute != router.query.route && endpoint === null && !categoryLoaders.fetchingCategory){
                    handleShallowLink(null, router.query.route);
                }
            }

            asyncFunction();
        }
    }, [router.query])

    useEffect(() => {
        if(categoryState?.category?.category_id){
            // setCatData(categoryState);
            setCategorySort(categoryState.sort);
            setCategoryAvailableFilters(categoryState.filters);
            setCategorySelectedFilters(categoryState.selected_filters);
            // setCategoryProducts(categoryState.products);
            setCategoryTotalProductCount(categoryState.total_product_count);
            const chosen_filters = selected_filters;
            updateIsChecked(filters, chosen_filters);
            setFilterCheckboxValue(false);
        }
    }, [categoryState?.category?.category_id])
    


    //add product then update cart
    // useEffect(() => {
    //     products && setCategoryProducts(products);
    // }, [products]);

    useEffect(() => {
        setCategoryAvailableFilters(filters);
        const chosen_filters = selected_filters;
        updateIsChecked(filters, chosen_filters);
    }, [filters]);



    //when the filter checkbox updates, update the url, product, filters, selected filters and total product count
    useEffect(() => {
        // console.log(isFirstRender);
        //if it is the first render don't change the page url
        if (isFirstRender.current == true) {
            isFirstRender.current = "first";
            return; // return early if initial render
        } else if (isFirstRender.current == "first") {
            isFirstRender.current = false;
            return
        }
        getFilters();
    }, []);


    //if a checkbox clicked
    useEffect(() => {
        if (filterCheckboxValue == true) {
            getFilters();
            setFilterCheckboxValue(false);
        } else {
            return;
        }
    }, [filterCheckboxValue]);


    // Functions


    // const updateData = async (data) => {
    //     setCategorySort(data.sort);
    //     setCategoryAvailableFilters(data.filters);
    //     setCategorySelectedFilters(data.selected_filters);
    //     setCategoryProducts(data.products);
    //     setCategoryTotalProductCount(data.total_product_count);
    //     setIsChecked([]);
    //     setFilterCheckboxValue(data.filterCheckboxValue);
    //     setCatData(data);
    // }

    const updateIsChecked = (filters, chosen_filters) => {
        //initiate the filter checkbox value using the available filters and selected filters
        var isCheckedArray = [];
        if (isDefined(filters) && Object.keys(filters).length > 0 && chosen_filters != null) {
            Object.keys(filters).map((filter_type) => {
                var filter_option_array = [];
                if (filters[filter_type] && filters[filter_type].options) {
                    filters[filter_type].options.forEach((filter_option) => {
                        //if the filter option is present in the selected filters then mark the checked value is true
                        var checkedValue =
                            chosen_filters[filter_type] &&
                            chosen_filters[filter_type].includes(
                                filter_option.slug
                            )
                                ? true
                                : false;
                        filter_option_array.push({
                            name: filter_option.slug,
                            checked: checkedValue,
                        });
                    });
                }
                isCheckedArray[filter_type] = filter_option_array;
            });
        }
        setIsChecked(isCheckedArray);
    };
  
    //get filters and new products and update the ischecked array
    const getFilters = () => {
        loadingProducts.current = true;
        //sort value sent is '' to use the sort in the query
        const query_obj_and_str = getQueryObjandString("");
        //get the query obj, selected filters and uri
        let query_obj = query_obj_and_str.query_obj;
        const subRequest = query_obj_and_str.query_str;
        const new_selected_filters = query_obj_and_str.selected_filters;
 

        let get_base_products = false;
        if(Object.keys(new_selected_filters).length == 0){
            get_base_products = true;
            query_obj = [];
        }

        //update the page uri
        router.push(
            {
                pathname: "/" + router.query.route,
                query: query_obj,
            },
            undefined,
            { shallow: true }
        );
       
            const width = 360;
            const height = 360;
            const show_variants = !get_base_products ? 'no' : template_settings.show_product_variants;
            //get the products
            const include_all_in_uri = pricing_model == 1 ? `&include_all_in=true` : '';
            const products_uri =
                "products_v3?brand=" + process.env.brand.brand_key + "&slug=" +
                router.query.route +
                "&width=" +
                width +
                "&height=" +
                height +
                '&show_variants=' +
                show_variants +
                include_all_in_uri +
                subRequest;
            getRequest(products_uri).then((response) => {
                const new_products = response.data;
                // setCategoryProducts(new_products);
                dispatch({
                    type: categoryActions.SET_PRODUCTS,
                    payload: new_products
                })
            });
    

        //get the total product count
        const total_product_count_uri =
            "product-total-count-by-slug?brand=" + process.env.brand.brand_key + "&slug=" +
            router.query.route +
            "&width=" +
            width +
            "&height=" +
            height +
            subRequest;
        getRequest(total_product_count_uri).then((response) => {
            const new_total_product_count = response.data;
            //if null returned save count as 0
            if (new_total_product_count.hasOwnProperty("product_count")) {
                setCategoryTotalProductCount(
                    new_total_product_count.product_count
                );
            } else {
                setCategoryTotalProductCount(0);
            }
        });

        //get the new available filters
        const available_filters_uri =
            "product-filters-and-selected-filters?brand="+ process.env.brand.brand_key +"&slug=" +
            router.query.route +
            "&width=" +
            width +
            "&height=" +
            height +
            subRequest;
        getBaseRequest(available_filters_uri).then((response) => {
            const new_available_filters = response.data.filters;
            setCategoryAvailableFilters(new_available_filters);
            const new_selected_filters = response.data.selected_filters;
            setCategorySelectedFilters(new_selected_filters);
            updateIsChecked(new_available_filters, new_selected_filters);
            loadingProducts.current = false;
        });
    };
    

    //clear the filters
    const clearFilters = (e) => {
        //uncheck the array so all the products and filters can be retrieved
        setIsChecked({});
        setFilterCheckboxValue(true);
    };

    //toggle the filter checkbox value stored in the isChecked Array
    const toggleFilterCheckboxValue = (filter_type, filter_option) => {
        setIsChecked(function (prevState) {
            const newState = {
                ...prevState,
                [filter_type]: prevState?.[filter_type]?.map((el) => {
                    return el.name === filter_option
                        ? {
                              ...el,
                              checked: !el.checked,
                          }
                        : el;
                }),
            };
            return newState;
        });
        setFilterCheckboxValue(true);
    };

    //get the query object and string using the ischecked array
    const getQueryObjandString = (sort_type) => {
        var new_selected_filters = [];
        var subRequest = "";
        var query_obj = {};
        Object.keys(isChecked).map((filter_type) => {
            isChecked?.[filter_type]?.forEach((filter_option_checkbox) => {
                var slug = "";
                if (filter_option_checkbox.checked == true) {
                    slug = filter_option_checkbox.name;
                }
                if (filter_type in new_selected_filters && slug != "") {
                    new_selected_filters[filter_type].push(slug);
                } else if (slug != "") {
                    new_selected_filters[filter_type] = [slug];
                }
            });
        });
        //create the filters query param
        if (Object.keys(new_selected_filters).length > 0) {
            const filter_types_str =
                Object.keys(new_selected_filters).join("|");
            query_obj["filters"] = filter_types_str;
            subRequest = subRequest + "&filters=" + filter_types_str;
        }

        //create the query params for the selected filter types
        Object.keys(new_selected_filters).map((filter_type, index) => {
            const filter_name = "f-" + filter_type;
            const filter_options_str =
                new_selected_filters[filter_type].join("|");
            subRequest =
                subRequest + "&" + filter_name + "=" + filter_options_str;
            query_obj[filter_name] = filter_options_str;
        });

        //if the sort value is given then this is the new sort
        if (sort_type != "") {
            subRequest = subRequest + "&sort=" + sort_type;
            query_obj["sort"] = sort_type;
            //else if the sort is in the query then use that
        } else if ("sort" in router.query) {
            const sort_choice = router.query["sort"];
            subRequest = subRequest + "&sort=" + sort_choice;
            query_obj["sort"] = sort_choice;
            //if it is not there as well then use the category sort value from the category data
        } else if (category_sort != "") {
            subRequest = subRequest + "&sort=" + category_sort;
            query_obj["sort"] = category_sort;
        }
        return {
            query_obj: query_obj,
            query_str: subRequest,
            selected_filters: new_selected_filters,
        };
    };

    //when a new sort is selected the products are updated
    const handleCategorySortChange = (event) => {
        var categorySort = event.target.value;
        //encode the changed value
        var new_sort_type = encodeURI(categorySort);

        const query_obj_and_str = getQueryObjandString(new_sort_type);
        setCategorySort(new_sort_type);
        const query_obj = query_obj_and_str.query_obj;
        const subRequest = query_obj_and_str.query_str;

        //change the url
        router.push(
            {
                pathname: "/" + router.query.route,
                query: query_obj,
            },
            undefined,
            { shallow: true }
        );

        //ajax call to get the sorted products
        const width = 360;
        const height = 360;
        const include_all_in_uri = pricing_model == 1 ? `&include_all_in=true` : '';
        const products_uri =
            "products_v3?brand=" + process.env.brand.brand_key + "&slug=" +
            router.query.route +
            "&width=" +
            width +
            "&height=" +
            height +
            include_all_in_uri +
            subRequest;
        getRequest(products_uri).then((response) => {
            const new_products = response.data;
            // setCategoryProducts(new_products);
            dispatch({
                type: categoryActions.SET_PRODUCTS,
                payload: new_products
            })
        });
    };

    const value = { 
        loadingProducts,

        //states
        category_sort,
        available_filters,
        selected_category_filters,
        categoryProducts,
        isChecked,
        catData,

        //functions
        updateIsChecked,
        getFilters,
        clearFilters,
        toggleFilterCheckboxValue,
        getQueryObjandString,
        handleCategorySortChange,
     };
    return (
        <CategoryContext.Provider value={value}>{children}</CategoryContext.Provider>
    );
};
